import React, { useContext, useState } from "react";
import { APIContext } from "../../api";
import { ProjectDataContext } from "../../context/projectContext";

export default function ProjectAnalytics({ projectID }) {
  const { setProjectAnalyticsDisabled } = useContext(APIContext);
  const { projectData, setProjectData } = useContext(ProjectDataContext);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const disabled = projectData.grigoraAnalyticsDisabled === true;

  async function toggle() {
    if (saving) return;
    setSaving(true);
    setError("");
    try {
      const result = await setProjectAnalyticsDisabled(projectID, !disabled);
      setProjectData((current) => ({
        ...current,
        grigoraAnalyticsDisabled: result.disabled,
      }));
    } catch (err) {
      setError(
        err?.response?.data?.message || "Could not save analytics setting. Try again."
      );
    } finally {
      setSaving(false);
    }
  }

  return (
    <section
      className="w-full rounded-xl border border-slate-200 bg-slate-50 p-4 mb-6"
      aria-label="Grigora analytics"
    >
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="font-semibold text-slate-900">Disable Grigora analytics</h2>
          <p className="mt-1 text-sm text-slate-600">
            Stop adding the built-in analytics script to this website.
            Existing analytics history and other analytics integrations are preserved.
          </p>
          <p id="analytics-publish-note" className="mt-1 text-xs text-slate-500">
            Republish the website after changing this setting to update live pages.
          </p>
        </div>
        <button
          type="button"
          role="switch"
          aria-label="Disable Grigora analytics"
          aria-describedby="analytics-publish-note"
          aria-checked={disabled}
          disabled={saving}
          onClick={toggle}
          className={`shrink-0 rounded-full px-4 py-2 text-sm font-semibold disabled:opacity-50 ${
            disabled
              ? "bg-[#623ce7] text-white"
              : "border border-slate-300 bg-white text-slate-700"
          }`}
        >
          {saving ? "Saving…" : disabled ? "On" : "Off"}
        </button>
      </div>
      {error && <p role="alert" className="mt-2 text-sm text-red-700">{error}</p>}
    </section>
  );
}
